import { takeLeading, call, getContext, select, put } from "redux-saga/effects";
import { ISetLanguage, setLanguage } from "./authActions";
import { ISgAuthService } from "../../../../sg-auth/services/SgAuthService";
import { selectToken } from "./authSelectors";

const createSetLanguageSaga = () =>
    function* saga(action: ISetLanguage) {

        const authService: ISgAuthService = yield getContext("auth");
        const token: string = yield select(selectToken);
        //@ts-ignore
        const loginResponse: any = yield call(authService.changeSessionLanguage, action.payload.language, token);
        yield put({ type: "RELOAD_APP" })

    };

export default function () {
    return takeLeading(
        setLanguage,
        createSetLanguageSaga(),
    );
}
